/* import __COLOCATED_TEMPLATE__ from './first-time-ux-banner.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { get as getFromLocalStorage, set as setToLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { hasConsent, OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
const LOCAL_STORAGE_PREFIX = 'dashboard.first-time-ux.banner';
/**
 * A `market-banner` wrapper to display First-Time User Experience:
 * Checks local storage for the passed-in `token` to determine whether to
 * show the banner. The banner is shown until manually dismissed.
 * Nothing is shown if localStorage cannot be accessed to avoid unskippable
 * banners.
 *
 * Example usage:
 * <FirstTimeUx::FirstTimeUxBanner @token={{"uniqueTokenForComponent"}}>
 *   {{t-i18n "firstTimeUxBanner"}}
 * </FirstTimeUx::FirstTimeUxBanner>
 *
 * @class FirstTimeUXBanner
 * @extends {Component}
 * @param {String} [token] Required string that will be combined with a default
 * prefix and the user's merchant token to create the key used in local storage
 * that will store whether or not the banner has been previously dismissed.
 * @param {String} [className] Optional class name for the banner container.
 */
let FirstTimeUXBannerComponent = (_dec = computed('args.showWithoutCookies', 'hasCookieConsent', 'previouslyDismissed'), _class = class FirstTimeUXBannerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "hasCookieConsent", _descriptor2, this);
    _initializerDefineProperty(this, "previouslyDismissed", _descriptor3, this);
  }
  get token() {
    const {
      merchantToken
    } = this.userInfo;
    const argToken = this.args.token;
    return `${LOCAL_STORAGE_PREFIX}.${argToken}.${merchantToken}`;
  }
  get bannerDisabled() {
    if (!this.hasCookieConsent && this.args.showWithoutCookies) {
      return false;
    }
    return this.previouslyDismissed || !this.hasCookieConsent;
  }
  onBannerDismiss() {
    this.previouslyDismissed = true;
    setToLocalStorage(this.token, true, OneTrustConsent.FUNCTIONAL);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasCookieConsent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return hasConsent(OneTrustConsent.FUNCTIONAL);
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "previouslyDismissed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Boolean(getFromLocalStorage(this.token));
  }
}), _applyDecoratedDescriptor(_class.prototype, "bannerDisabled", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "bannerDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBannerDismiss", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBannerDismiss"), _class.prototype), _class);
export { FirstTimeUXBannerComponent as default };